// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__joMyz","question":"styles_question__2fUNb","description":"styles_description__1EuI0"};